import {changeEvent, dispatchCustomEvent} from "../../../../../../../webpack/modules/events";
import {isDesktop} from "../../../../../../../webpack/modules/devices";
import {updatePriceElements, updateSizesPrices} from "../../../../../../../webpack/modules-optimized/product-list";

changeEvent('#product-list-page .product-configuration-color[data-option-type="selectable"] input[name="color"]', true, function(element) {
    let configurationMain = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration');
    let previewElement = configurationMain.querySelector('.open-configuration .preview-option-color');
    let input = configurationMain.querySelector('input[name="option-color"]');

    container.querySelectorAll('.color-item-selectable.selected').forEach(option => option.classList.remove('selected'));
    element.nextElementSibling.classList.add('selected');
    dispatchCustomEvent(
        'productColorChanged',
        {
            'option': container,
            'previewElement': previewElement,
            'colorSelected': element.value
        }
    );
    input.value = element.value;
    updatePriceElements(container);
    updateSizesPrices(container);
    container.dataset.completed = 'true';
    dispatchCustomEvent('productListProductConfigurationChanged');
});